import { Button } from "@components/button/button-untitledui";
import { Check, Download01, Upload01 } from "@untitledui/icons";
import { useCallback, useMemo } from "react";
import Select, { type MultiValue } from "react-select";
import {
	motoristaCategoriasView,
	motoristaExportar,
} from "@/services/analytics/events";
import { CATEGORY_OPTIONS, SELECT_STYLES } from "../constants";
import { useExportDrivers } from "../hooks";
import type {
	CategoryFilterProps,
	DriversListActionsProps,
	Option,
} from "../types";
import { exportDriversCsv } from "../utils";

export const CategoryFilter = ({
	selectedCategories,
	onSelectedCategoriesChange,
	onPageChange,
	hasAnyDrivers,
	inputId,
}: CategoryFilterProps) => {
	const categoryOptions = useMemo<Option[]>(
		() =>
			CATEGORY_OPTIONS.map((cat) => ({
				value: cat,
				label: cat,
			})),
		[]
	);

	const handleCategoryChange = useCallback(
		(options: MultiValue<Option> | null) => {
			onSelectedCategoriesChange((options ?? []) as readonly Option[]);
			onPageChange(1);
			const categorias = options?.map((opt) => opt.value) ?? [];
			motoristaCategoriasView(categorias);
		},
		[onSelectedCategoriesChange, onPageChange]
	);

	return (
		<Select<Option, true>
			className="w-full"
			classNamePrefix="react-select"
			formatOptionLabel={(option, { context }) =>
				context === "menu" ? (
					<div className="flex items-center justify-between">
						<span>{option.label}</span>
						{selectedCategories.some((s) => s.value === option.value) && (
							<Check className="h-4 w-4 text-primary-500" />
						)}
					</div>
				) : (
					option.label
				)
			}
			hideSelectedOptions={false}
			inputId={inputId}
			isDisabled={!hasAnyDrivers}
			isMulti
			onChange={handleCategoryChange}
			options={categoryOptions}
			placeholder="Selecionar categorias"
			styles={SELECT_STYLES}
			value={selectedCategories}
		/>
	);
};

export const DriversListActions = ({
	onClickBatchRegister,
	hasResults,
}: DriversListActionsProps) => {
	const { mutate: exportDrivers, isPending: isExporting } = useExportDrivers();

	const handleExport = useCallback(() => {
		motoristaExportar();
		exportDrivers(undefined, {
			onSuccess: (drivers) => {
				if (!drivers?.length) {
					return;
				}

				exportDriversCsv(drivers);
			},
		});
	}, [exportDrivers]);

	return (
		<>
			<Button
				color="secondary"
				iconLeading={Download01}
				isDisabled={!hasResults || isExporting}
				onClick={handleExport}
				size="sm"
			>
				{isExporting ? "Exportando..." : "Exportar dados"}
			</Button>

			<Button
				color="primary"
				iconLeading={Upload01}
				onClick={onClickBatchRegister}
				size="sm"
			>
				Cadastrar lote
			</Button>
		</>
	);
};
